<!--
 * @Author: 孙照
 * @LastEditTime: 2023-08-18 15:27:54
 * @Description: 累计减碳量
 * @FilePath: \monitor\fuzhou\src\module\overview\rightContent\totalCarbonReduction.vue
-->
<template>
  <div class="green-energy-percent">
    <div class="content">
      <div class="item">
        <img class="tag-img" src="@/assets/images/social.png" alt="">
        <img class="small-arrow-img" src="@/assets/images/carbonIcon.png" alt="">
        <div class="item-content">
          <div class="item-title">碳减排</div>
          <div class="item-value">
            <span
              class="value"
              :class="[totalCarbonReductionData > 10000 ? 'too-long-value' : '']"
            >
            {{ formatNumber(totalCarbonReductionData) }}
            </span>
            <span class="unit">{{totalCarbonReductionData > 10000? '吨':'千克' }}</span>
          </div>
        </div>
      </div>

      <div class="item">
        <img class="small-arrow-img" src="@/assets/images/treeIcon.png" alt="">
        <div class="item-content">
          <div class="item-title">相当于植树</div>
          <div class="item-value">
            <span class="value">{{ treeNumber }}</span>
            <span class="unit">平方米</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatNumber } from '@/utils';

export default {
  name: 'greenEnergyPercent',
  props: {
    totalCarbonReductionData: {
      type: Number,
      default: 0,
    },
  },
  filters: {
    // 保留两位小数
    toFixed (value) {
      return value.toFixed(2);
    },
  },
  computed: {
    treeNumber () {
      return ((this.totalCarbonReductionData / 8) * 4).toFixed(0);
    },
  },
  methods: {
    formatNumber,
  },
};

</script>

<style lang="less" scoped>
.green-energy-percent {
  margin-top: 30px;
  .content {
    box-sizing: border-box;
    box-sizing: border-box;
    .displayFlex(center, center);

    .item {
      height: 69px;
      box-sizing: border-box;
      .displayFlex(flexStart, center);
      position: relative;

      .tag-img {
        width: 206px;
        height: 50px;
        position: absolute;
        left: -160px;
        top: 50%;
        transform: translateY(-50%);
      }

      &:first-child {
        margin-right: 53px;
      }

      .small-arrow-img {
        width: 69px;
        height: 69px;
      }

      .item-content {
        .item-title {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          text-shadow: 0px 1px 4px #42CAFF;
        }
        .item-value {
          margin-left: 12px;
          box-sizing: border-box;
          .displayFlex(flexStart, baseline);

          .value {
            font-size: 30px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #FFFFFF;
            text-shadow: 0px 0px 8px #00B2FF;
          }

          .too-long-value {
            font-size: 30px;
          }

          .unit {
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            text-shadow: 0px 0px 8px #00B2FF;
          }
        }
      }
    }
  }
}
</style>
